<template>
  <button
    v-if="move"
    class="moveButton button is-small is-fullwidth is-outlined"
    :class="(isFocused && 'is-info is-focused ') + (isPlaying && 'is-success')"
    @click="!isPlaying && $emit('onClick', move.moveIndex)"
  >
    <b-tooltip
      type="is-light"
      position="is-bottom"
      class="has-text-left"
      :append-to-body="true"
    >
      <p style="padding: 0 0.5rem">
        {{ move.move }}
      </p>

      <template v-slot:content>
        <p>
          <span class="image is-16x16" style="float: left">
            <img :src="piece_color | chessPieceSvg" alt="" />
          </span>
          <span>
            <i>&nbsp;{{ move.createdAt | asDayjsFormat("hh:mm:ss A") }}</i>
          </span>
        </p>
        <p>
          {{ move.isPremove ? "premove" : "move" }}:
          <b class="has-text-info">{{ move.moveTime.toFixed(2) }}s</b>
        </p>
        <p v-if="move.bufferTime">
          buffer:
          <i class="has-text-success">{{ move.bufferTime.toFixed(2) }}s</i>
        </p>
        <p>e2e: {{ move.e2eTime.toFixed(2) }}s</p>

        <p>actual: {{ move.actualMoveTime.toFixed(2) }}s</p>
        <p>⏰ used: {{ move.timeUsed | asMmSsFloat }}</p>
        <p>
          ⏰ left: {{ move.timeLeft | asMmSsFloat }}
          <i v-if="move.increment">(+{{ move.increment }})</i>
        </p>
        <p>buffer used: {{ move.bufferUsed.toFixed(2) }}s</p>
        <p>buffer left: {{ move.bufferLeft.toFixed(2) }}s</p>
      </template>
    </b-tooltip>

    <b-tooltip
      type="is-light"
      position="is-left"
      class="moveStatus"
      :append-to-body="true"
    >
      <span class="moveStatus__text">
        {{ move.createdAt ? "✓" : "" }}{{ move.received ? "✓" : "" }}
      </span>
      <template v-slot:content>
        <p>
          sent:
          <i>{{ move.createdAt | asDayjsFormat("HH:mm:ss") }}</i>
        </p>

        <p v-if="move.localTimestamp">
          <span>
            local:
            <i>&nbsp;{{ move.localTimestamp | asDayjsFormat("hh:mm:ss A") }}</i>
          </span>
        </p>
        <p v-if="move.timeOffset">
          time offset:
          <i class="has-text-danger">{{ move.timeOffset.toFixed(2) }}s</i>
        </p>
        <p v-if="move.moveTimestamp">
          timestamp:
          <i>&nbsp;{{ move.moveTimestamp | asDayjsFormat("HH:mm:ss") }}</i>
        </p>

        <p v-if="move.received">
          received:
          <i>{{ move.receivedAt | asDayjsFormat("HH:mm:ss") }}</i>
        </p>
        <p v-else-if="move.received === false" class="has-text-danger">
          not yet received
        </p>

        <p v-if="move.received">
          duration:
          <b>{{ move.sendTime.toFixed(2) }}s</b>
        </p>
      </template>
    </b-tooltip>
  </button>
</template>

<script>
import { CHESS_PIECES } from "vue-chess-shared/constants";

export default {
  name: "MoveButton",

  props: ["move", "isFocused", "isPlaying"],

  computed: {
    piece() {
      if (!this.move || !this.move.move || !this.move.move.length) return "";
      const c = this.move.move[0];
      if (CHESS_PIECES[c]) return CHESS_PIECES[c];
      return CHESS_PIECES.P;
    },

    color() {
      return this.move?.color ?? "";
    },

    piece_color() {
      return this.piece + "_" + this.color;
    },
  },
};
</script>

<style scoped>
.moveButton {
  position: relative;
}

.moveStatus {
  position: absolute;
  right: 0rem;
  bottom: 0;
}

.moveStatus__text {
  padding: 0 0.5rem;
  letter-spacing: -0.35rem;
  font-weight: 200;
  font-size: 0.7rem;
}
</style>
